import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'components';
import { COUPON_STATES } from 'coupon-common';
import CouponTilted from '../../../assets/icons/Coupon_TiltedIcon.svg';
import AddIcon from '../../../assets/icons/Add_Icon.svg';
import FilterIcon from '../../../assets/icons/Filter_Icon.svg';
import { ReactComponent as GlobIcon } from '../../../assets/icons/Glob_Icon.svg';
import { ReactComponent as GlobHiddenIcon } from '../../../assets/icons/Glob_HiddenIcon.svg';
import RedirectButtonIcon from '../../../assets/icons/Redirect_ButtonIcon.svg';
import { useNavigate } from 'react-router-dom';

const CouponsSidebar = ({ couponsList, isCouponsFetching, viewCounts, onDeleteCoupon }) => {
  const [filter, setFilter] = useState('PUBLISHED');
  const [collapsed, setCollapsed] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  const navigate = useNavigate();

  const published = useMemo(() => couponsList.filter(c => c.state === COUPON_STATES.PUBLISHED), [couponsList]);
  const draft = useMemo(() => couponsList.filter(c => c.state === COUPON_STATES.DRAFT), [couponsList]);
  const expired = useMemo(
    () => couponsList.filter(c => c.state !== COUPON_STATES.PUBLISHED && c.state !== COUPON_STATES.DRAFT),
    [couponsList],
  );

  const filtered = filter === 'PUBLISHED' ? published : filter === 'DRAFT' ? draft : expired;

  const isExpiredCoupon = (coupon) => {
    if (!coupon.expiry_date) return false;
    return new Date(coupon.expiry_date) < new Date();
  };

  return (
    <div style={{
        background: '#ECECEC', borderRadius: '22px', padding: '20px 16px', width: '100%',
        fontFamily: "'Segoe UI', sans-serif",
        height: collapsed ? 'auto' : '575px',
        display: 'flex', flexDirection: 'column',
      }}>
       <style>{`
        .coupon-list-scroll {
          scrollbar-width: thin;
          scrollbar-color: #d0c8c8 transparent;
        }
        .coupon-list-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .coupon-list-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .coupon-list-scroll::-webkit-scrollbar-thumb {
          background: #d0c8c8;
          border-radius: 10px;
        }
        .coupon-list-scroll::-webkit-scrollbar-thumb:hover {
          background: #b8acac;
        }
      `}</style>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: collapsed ? 0 : '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={CouponTilted} style={{ width: '28px' }} />
          <span style={{ fontSize: '22px', fontWeight: '400', color: '#1a1a1a' }}>Coupons</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            style={{ width: '28px', height: '28px', borderRadius: '7px', border: '1px solid #ddd', background: '#f5f5f5', cursor: 'pointer', fontSize: '10px', color: '#666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={() => setCollapsed(o => !o)}
            title={collapsed ? 'Expand' : 'Collapse'}
          >
            {collapsed ? '▼' : '▲'}
          </button>
          <button
            style={{ width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, #EF0023, #D4001D)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(212,0,29,0.35)' }}
            onClick={() => (window.location.href = '/coupons/create')}
          >
            <img src={AddIcon} style={{ width: '16px' }} />
          </button>
        </div>
      </div>

      {!collapsed && (
        <>
          {/* Count row */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '2px' }}>
              <span style={{ fontSize: '32px', fontWeight: '300', color: '#1a1a1a', lineHeight: 1 }}>
                {String(filtered.length).padStart(2, '0')}
              </span>
              <span style={{ fontSize: '28px', fontWeight: '200', color: '#bbb', lineHeight: 1 }}>/</span>
              <span style={{ fontSize: '28px', fontWeight: '300', color: '#999', lineHeight: 1 }}>
                {String(couponsList.length).padStart(2, '0')}
              </span>
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
              {/* <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '3px', display: 'flex', alignItems: 'center' }}>
                <img src={FilterIcon} style={{ width: '28px' }} />
              </button> */}
              <button
                onClick={() => navigate('/coupons')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '3px', display: 'flex', alignItems: 'center' }}
              >
                <img src={RedirectButtonIcon} style={{ width: '28px' }} />
              </button>
            </div>
          </div>

          {/* Filter tabs */}
          <div style={{ display: 'flex', gap: '0', marginBottom: '12px', background: 'white', borderRadius: '11px', padding: '3px' }}>
            {[
              { key: 'PUBLISHED', Icon: GlobIcon, label: 'Published' },
              { key: 'DRAFT', Icon: GlobHiddenIcon, label: 'Unpublished' },
            ].map(({ key, Icon, label }) => (
              <button
                key={key}
                onClick={() => setFilter(key)}
                style={{
                  flex: 1,
                  padding: '8px 10px',
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  background: filter === key ? '#1C1C1C' : 'transparent',
                  color: filter === key ? 'white' : '#888',
                  transition: 'all 0.15s',
                }}
              >
                <Icon style={{ width: '14px', height: '14px' }}
                  className={filter === key ? '[&_path]:fill-white' : '[&_path]:fill-[#888]'}
                />
                {label}
              </button>
            ))}
          </div>

          {/* Coupon list */}
          <div className="coupon-list-scroll" style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1, minHeight: 0, overflowY: 'auto' }}>
            {isCouponsFetching ? (
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Spinner show />
              </div>
            ) : filtered.length === 0 ? (
              <p style={{ color: '#aaa', fontSize: '13px', textAlign: 'center', padding: '16px 0', margin: 0 }}>
                No {filter === 'PUBLISHED' ? 'published' : 'draft'} coupons yet
              </p>
            ) : (
              filtered.map(coupon => {
                const isExpired = isExpiredCoupon(coupon);
                const isOpen = expandedId === coupon.id;

                return (
                  <div key={coupon.id}>
                    {/* Card row */}
                    <div
                      onClick={() => setExpandedId(isOpen ? null : coupon.id)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '12px 12px',
                        background: 'white',
                        borderRadius: isOpen ? '14px 14px 0 0' : '14px',
                        cursor: 'pointer',
                      }}
                    >
                      {/* Status icon */}
                      {isExpired ? (
                        <div style={{ width: '26px', height: '26px', borderRadius: '50%', border: '2px solid #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <line x1="1.5" y1="1.5" x2="8.5" y2="8.5" stroke="#aaa" strokeWidth="1.6" strokeLinecap="round"/>
                            <line x1="8.5" y1="1.5" x2="1.5" y2="8.5" stroke="#aaa" strokeWidth="1.6" strokeLinecap="round"/>
                          </svg>
                        </div>
                      ) : (
                        <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <polyline points="2.5,6 5,9 9.5,3.5" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                      )}

                      {/* Info */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: '600', fontSize: '13.5px', color: '#1a1a1a', marginBottom: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {coupon.title}
                        </div>
                        <div style={{ fontSize: '11px', color: isExpired ? '#D4001D' : '#999' }}>
                          {isExpired ? 'Expired' : 'Expire'} :{' '}
                          {coupon.expiry_date
                            ? new Date(coupon.expiry_date).toLocaleDateString('en-US', { month: 'short', day: '2-digit' })
                            : 'No expiry'}
                        </div>
                      </div>

                      {/* Stats */}
                      {/* <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', alignItems: 'flex-end' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M6 10.5S1 7 1 4A2.5 2.5 0 0 1 6 2.8 2.5 2.5 0 0 1 11 4C11 7 6 10.5 6 10.5Z" fill="#6B0020" stroke="#6B0020" strokeWidth="0.5"/>
                          </svg>
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#555' }}>{coupon.save_coupon_count || 0}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M1 6S3 2.5 6 2.5 11 6 11 6 9 9.5 6 9.5 1 6 1 6Z" stroke="#444" strokeWidth="1.1"/>
                            <circle cx="6" cy="6" r="1.3" fill="#444"/>
                          </svg>
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#555' }}>{viewCounts?.[coupon.id] || 0}</span>
                        </div>
                      </div> */}
                    </div>

                    {/* Expanded: Delete + Edit */}
                    {isOpen && (
                      <div style={{ background: 'white', borderRadius: '0 0 14px 14px', padding: '0 12px 12px', display: 'flex', gap: '8px' }}>
                        <button
                          onClick={(e) => { e.stopPropagation(); setConfirmDeleteId(coupon.id); }}
                          style={{ flex: 1, padding: '9px 0', borderRadius: '9px', border: '1.5px solid #D4001D', background: 'transparent', color: '#D4001D', fontWeight: '600', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            {[2,6,10].flatMap(x => [2,6,10].map(y => <circle key={`${x}-${y}`} cx={x} cy={y} r="1" fill="#D4001D"/>))}
                          </svg>
                          Delete
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); navigate(`/coupons/${coupon.id}?mode=edit&step=5`); }}
                          style={{ flex: 1, padding: '9px 0', borderRadius: '9px', border: 'none', background: 'linear-gradient(135deg, #EF0023, #D4001D)', color: 'white', fontWeight: '600', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', boxShadow: '0 3px 8px rgba(212,0,29,0.3)' }}
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            {[2,6,10].flatMap(x => [2,6,10].map(y => <circle key={`${x}-${y}`} cx={x} cy={y} r="1" fill="white"/>))}
                          </svg>
                          Edit
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </>
      )}

      {confirmDeleteId !== null && (
        <div
          onClick={() => setConfirmDeleteId(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white', borderRadius: '16px', padding: '24px',
              width: '90%', maxWidth: '340px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
            }}
          >
            <h5 style={{ margin: '0 0 8px', color: '#1a1a1a' }}>Delete coupon?</h5>
            <p style={{ margin: '0 0 20px', fontSize: '13px', color: '#777' }}>
              This can't be undone. Are you sure you want to delete this coupon?
            </p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={() => setConfirmDeleteId(null)}
                style={{ flex: 1, padding: '10px 0', borderRadius: '9px', border: '1.5px solid #ddd', background: 'white', color: '#555', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onDeleteCoupon && onDeleteCoupon(confirmDeleteId);
                  setConfirmDeleteId(null);
                }}
                style={{ flex: 1, padding: '10px 0', borderRadius: '9px', border: 'none', background: 'linear-gradient(135deg, #EF0023, #D4001D)', color: 'white', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CouponsSidebar.propTypes = {
  couponsList: PropTypes.array.isRequired,
  isCouponsFetching: PropTypes.bool,
  viewCounts: PropTypes.object,
  history: PropTypes.object.isRequired,
  onDeleteCoupon: PropTypes.func,
};

export default CouponsSidebar;